'use client';

import Image from 'next/image';
import { useTotemActions, useTotemCatalog } from '@/features/totems/presentation/providers/web-totem/totem-provider';
import { cn } from '@/shared/utils/utils';

export function TotemCategorySidebar() {
  const { categories, activeCategoryId, searchQuery } = useTotemCatalog();
  const { setActiveCategoryId } = useTotemActions();

  if (searchQuery.trim()) return null;

  return (
    <aside className="flex shrink-0 bg-muted/30 transition-all duration-300 portrait:h-auto portrait:w-full portrait:flex-row portrait:border-b landscape:h-full landscape:w-[104px] landscape:flex-col landscape:border-r">
      <div className="flex h-full w-full overflow-x-auto overflow-y-hidden landscape:overflow-x-hidden landscape:overflow-y-auto [&::-webkit-scrollbar]:hidden">
        <nav className="flex gap-2 p-3 portrait:flex-row portrait:items-center landscape:w-full landscape:flex-col landscape:items-center">
          {categories.map(category => {
            const isActive = category.id === activeCategoryId;

            return (
              <button
                key={category.id}
                type="button"
                className={cn(
                  'flex flex-col items-center justify-start gap-2 rounded-2xl p-2 text-center transition-colors portrait:min-w-[5rem] landscape:w-full',
                  isActive ? 'bg-background shadow-sm' : 'bg-transparent hover:bg-muted/50'
                )}
                title={category.name}
                onClick={() => setActiveCategoryId(category.id)}
              >
                <div className="relative size-14 shrink-0 overflow-hidden rounded-xl bg-background shadow-sm">
                  {category.image_url ? (
                    <Image alt={category.name} className="object-cover" fill sizes="56px" src={category.image_url} />
                  ) : (
                    <div className="flex size-full items-center justify-center text-xs text-muted-foreground">
                      {category.name.slice(0, 1)}
                    </div>
                  )}
                </div>
                <span
                  className={cn(
                    'text-xs leading-tight font-semibold',
                    isActive ? 'text-foreground' : 'text-muted-foreground'
                  )}
                >
                  {category.name}
                </span>
              </button>
            );
          })}
        </nav>
      </div>
    </aside>
  );
}
